// Default custom class mapping based on notification type
const defaultCustomClassMap = {
    success: 'notification-unlock',
    warning: 'notification-lock',
    error: 'notification-lock',
    info: ''
}

// Chỉ cho phép 1 popup tại một thời điểm; khi user spam click thì queue chỉ giữ bản tin mới nhất
let isShowing = false
let pendingItem = null

function showInternal(instance, type, message, options) {
    const customClass = options.customClass !== undefined
        ? options.customClass
        : defaultCustomClassMap[type] || ''

    const opts = {
        showClose: true,
        message,
        type,
        duration: options.duration || 3000,
        offset: options.offset || 20,
        customClass,
        ...options,
        onClose: () => {
            isShowing = false
            if (options.onClose) options.onClose()
            if (pendingItem) {
                const next = pendingItem
                pendingItem = null
                isShowing = true
                showInternal(next.instance, next.type, next.message, next.options)
            }
        }
    }
    instance.$message(opts)
}

export function showNotication(instance, type, message, options = {}) {
    const item = { instance, type, message, options }

    if (isShowing) {
        pendingItem = item
        return
    }

    isShowing = true
    showInternal(instance, type, message, options)
}

export function showColoredNotification(instance, type, message, options = {}) {
    return showNotication(instance, type, message, options)
}


